import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ExternalService {
  constructor(protected http: HttpClient) {}

  getPublicHolidays() {
    return this.http.get(
      'https://calendrier.api.gouv.fr/jours-feries/metropole.json'
    );
  }
}
